import React, { useState } from 'react';
import { Menu, X } from 'lucide-react'; // optional, you can use any icon set you like

function Sidebar({ activeItem, onNavigate }) {
  const [isOpen, setIsOpen] = useState(false);

  const handleNavigate = (path) => {
    onNavigate(path);
    setIsOpen(false); // Close drawer after navigation
  };

  return (
    <>
      {/* ======= Hamburger Icon (Mobile Only) ======= */}
      <div className="lg:hidden fixed top-13 left-5 z-50">
        <button
          onClick={() => setIsOpen(true)}
          className="p-2 bg-[#2A668D] text-white rounded-md"
        >
          <Menu size={20} />
        </button>
      </div>

      {/* ======= Overlay ======= */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-40 z-40"
          onClick={() => setIsOpen(false)}
        />
      )}

      {/* ======= Sidebar ======= */}
      <div
        className={`
          fixed top-0 left-0 h-full w-64 bg-white shadow-xl rounded-r-xl z-50 md:z-0 md:mt-10 transform
          ${isOpen ? 'translate-x-0' : '-translate-x-full'}
          transition-transform duration-300 ease-in-out
          lg:static lg:translate-x-0 lg:rounded-xl lg:h-[100vh] lg:shadow-xl
        `}
      >
        <div className="p-5 flex flex-col justify-between h-full">
          {/* Close Button (Mobile Only) */}
          <div className="flex justify-end lg:hidden mb-4">
            <button
              onClick={() => setIsOpen(false)}
              className="p-1 text-gray-700"
            >
              <X size={24} />
            </button>
          </div>

          {/* Sidebar Items */}
          <ul className="space-y-4">
            <li>
              <button
                onClick={() => handleNavigate('/home/profilesetting/profile')}
                className={`block w-full text-left ${
                  activeItem === '/home/profilesetting/profile' ||
                  activeItem === '/home/profilesetting'
                    ? 'text-[#2A668D] font-bold'
                    : 'text-[#4C535F]'
                }`}
              >
                Profile
              </button>
            </li>

            <li>
              <button
                onClick={() => handleNavigate('/home/profilesetting/bookingHistory')}
                className={`block w-full text-left ${
                  activeItem.startsWith('/home/profilesetting/bookingHistory')
                    ? 'text-[#2A668D] font-bold'
                    : 'text-[#4C535F]'
                }`}
              >
                Booking History
              </button>
            </li>
          </ul>

          {/* Logout */}
          <div className="mt-8">
            <button
              onClick={() => {
                localStorage.clear();
                window.location.href = "/login";
              }}
              className="text-[#F02E2E] w-full text-left"
            >
              Logout
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default Sidebar;
